import { render, staticRenderFns } from "./SplitPanel.vue?vue&type=template&id=20bcecf1&scoped=true&"
import script from "./SplitPanel.vue?vue&type=script&lang=js&"
export * from "./SplitPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bcecf1",
  null
  
)

export default component.exports